import React from "react";
import {
  Dashboard
} from "../../_theme/_partials";

export function DashboardPage() {
  return <Dashboard />;
}
